import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../localization/language';
import { encryptPassword } from '../../utils';
import * as unlockActions from '../../actions/unlock';
 
import { checkPassword } from '../security/password/ChangePassword'

class UnlockChangePassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			curPwdErr: null,
			newPwdErr: null,
			confirmPwdErr: null,
			currentPassword: '',
			newPassword: '',
			confirmPassword: ''
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.validateInput()) {
			var encryptedCurrentPassword = encryptPassword(this.state.currentPassword);
			var encryptedNewPassword = encryptPassword(this.state.newPassword);
			this.props.unlockChangePassword(encryptedCurrentPassword, encryptedNewPassword);
		}
	}

	handleChangeCurrentPassword(event) {
		this.setState({currentPassword: event.target.value});
	}

	handleChangeNewPassword(event) {
		this.setState({newPassword: event.target.value});
	}

	handleChangeConfirmPassword(event) {
		this.setState({confirmPassword: event.target.value});
	}

	validateInput() {
		this.setState({
			curPwdErr: null,
			newPwdErr: null,
			confirmPwdErr: null
		});
		if (!this.state.currentPassword) {
			this.setState({curPwdErr: trans('error_password_required')});
			return false;
		}
		if (!checkPassword(this.state.newPassword)) {
			this.setState({newPwdErr: trans('reset_pwd_hint_v1')});
			return false;
		}
		if (this.state.newPassword !== this.state.confirmPassword) {
			this.setState({confirmPwdErr: trans('error_password_match')});
			return false;
		}
		return true;
	}

	getCurPwdError() {
		if (this.state.curPwdErr) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.state.curPwdErr}
				</div>
			);
		}
		if (this.props.unlock.status === 5) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{trans('error_verify_password')}
				</div>
			);
		}
	}

	getNewPwdError() {
		if (this.state.newPwdErr) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.state.newPwdErr}
				</div>
			);
		}
	}

	getConfirmPwdError() {
		if (this.state.confirmPwdErr) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.state.confirmPwdErr}
				</div>
			);
		}
	}

	render() {
		return (
			<div className="main">
				<div className="content">
					<div className="content-item content-item--ipage content-item--single">
						<div className="content-item__title">
							{trans('unlock_title')}
						</div>
						<div className="content-item__main">
							<div className="content-item--ipage__main">
								<div className="content__form">
									<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
										<div className="content__form-input">
											<input type="password" className="content__form-input-widget J-validated-field"
												placeholder={trans('current_password_placeholder')} id="J-form-curpwd"
												onChange={this.handleChangeCurrentPassword.bind(this)}>
											</input>
										</div>
										<div className="content__form-errmsg" id="J-errdisplay-curpwd">
											{this.getCurPwdError()}
										</div>
										<div className="changepwd-tip-wrap">
											<div className="content__form-input">
												<input type="password" className="content__form-input-widget J-validated-field"
													placeholder={trans('new_password_placeholder')} id="J-form-newpwd"
													onChange={this.handleChangeNewPassword.bind(this)}>
												</input>
											</div>
											<div id="J-form-pwdschecker" className="changepwd-strength">
												<div className="changepwd-strength__bar-wrap">
													<div className="changepwd-strength__bar"></div>
													<div className="changepwd-strength__bar"></div>
													<div className="changepwd-strength__bar"></div>
												</div>
												<div className="changepwd-strength__txt" data-txt-low="Low" data-txt-medium="Medium" data-txt-high="High"></div>
											</div>
										</div>
										<div className="content__form-errmsg" id="J-errdisplay-newpwd">
											{this.getNewPwdError()}
										</div>
										<div className="content__form-input">
											<input type="password" className="content__form-input-widget J-validated-field"
												placeholder={trans('confirm_password_placeholder')}
												onChange={this.handleChangeConfirmPassword.bind(this)}>
											</input>
										</div>
										<div className="content__form-errmsg" id="J-errdisplay-confirmpwd">
											{this.getConfirmPwdError()}
										</div>
										<div className="content__submit-wrap">
											<input type="submit" className="content__submit" value={trans('change_btn')}></input>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		unlock: state.unlock
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, unlockActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UnlockChangePassword);


// WEBPACK FOOTER //
// ./app/components/unlock/UnlockChangePassword.js